import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import SecondaryCta from 'bento-ordering/base/components/SecondaryCta';
import FulfillmentInformation from 'bento-ordering/cart/ui_components/FulfillmentInformation';

const NO_ADDRESS_MESSAGE =
  'Enter your address to see if we can deliver to you, or switch your order to pickup';

class CartDelivery extends React.Component {
  static propTypes = {
    handleClick: PropTypes.func,
    fulfillmentTimeOrASAP: PropTypes.string,
    fulfillmentAddress: PropTypes.string
  };

  render() {
    const {
      handleClick,
      fulfillmentTimeOrASAP,
      fulfillmentAddress
    } = this.props;

    return (
      <Box data-testid="fulfillment-information" width="100%" mb={2}>
        <Box mb={1.5}>
          {fulfillmentAddress && (
            <Box mr={2.5} display="inline">
              <FulfillmentInformation
                title="Delivery Time"
                info={fulfillmentTimeOrASAP}
                onClick={handleClick}
                dataTestId={'delivery-time'}
              />
            </Box>
          )}
          <FulfillmentInformation
            title="Deliver To"
            info={fulfillmentAddress || NO_ADDRESS_MESSAGE}
            onClick={fulfillmentAddress && handleClick}
            dataTestId={'deliver-to'}
          />
        </Box>
        <Box position="relative">
          {!fulfillmentAddress && (
            <Box display="inline" mb={2.5} mr={2.5}>
              <SecondaryCta
                handleClick={handleClick}
                dataTestId="cart-no-fulfillment-address"
                label="Enter Address"
              />
            </Box>
          )}
          <SecondaryCta
            handleClick={handleClick}
            dataTestId="cart-delivery"
            label={fulfillmentAddress ? 'Change' : 'Switch To Pickup'}
          />
        </Box>
      </Box>
    );
  }
}

export default CartDelivery;
